import { Button } from 'common/components';
import styles from './SelectAllBanner.module.scss';

interface SelectAllBannerProps {
    perPage: number;
    totalRecords: number;
    isAllPagesSelected: boolean;
    onSelectAllPages: () => void;
    onClearSelection: () => void;
}

export const SelectAllBanner = ({
    perPage,
    totalRecords,
    isAllPagesSelected,
    onSelectAllPages,
    onClearSelection,
}: SelectAllBannerProps) => {
    if (isAllPagesSelected) {
        return (
            <div className={styles.banner}>
                All {totalRecords.toLocaleString()} calls are selected.{' '}
                <Button variant='link' size='sm' onClick={onClearSelection}>
                    Clear selection
                </Button>
            </div>
        );
    }

    return (
        <div className={styles.banner}>
            All {perPage} calls on this page are selected.{' '}
            <Button variant='link' size='sm' onClick={onSelectAllPages}>
                Select all {totalRecords.toLocaleString()} calls matching current filters
            </Button>
        </div>
    );
};
